import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserModel } from '../models/user.model';

export const canAccesPrivateGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  // const canAccess = authService.getCurrentUser()?.client.key === 'C-95a684ae-9a57-466e-9028-ce953194b7f5';
  // if (canAccess) return true;
  // else {
  //   router.navigate(['/dashboard']);
  //   return false;
  // }
  return new Promise((resolve, reject) => {
    authService.getUserLogged().subscribe({
      next: (user: UserModel) => {
        if (user) {
          resolve(user.client.key === 'C-95a684ae-9a57-466e-9028-ce953194b7f5');
        }
      }, // Resolve with the first emitted value
      error: err => reject(err), // Reject if there is an error
      complete: () => {
        // Optionally handle completion if needed, though resolve will be called on the first emission
      },
    });
  });
};
